import { ColumnInterface } from "components/tables/interfaces";
import Table from "components/tables/table";
import { useLocale } from "stores/hooks/locale";
import { ListEntity } from "models/list-entity";
import { ListEntityField } from "models/list-entity-field";
import { Fragment, FunctionComponent, useEffect, useState } from "react";
import { userDoGetListEntityFields } from "services/user/list-entity-field";
import { EntityCollection } from "models/list-user-entity-collection";
import { userDoGetEntityCollections } from "services/user/entity-collection";
import { addEntityCollectionColumns } from "lib/schema";
import { useTranslate } from "stores/hooks/translation";

interface MultiSummaryTableProps {
  listUuid: string;
  listEntity: ListEntity;
}

const MultiSummaryTable: FunctionComponent<MultiSummaryTableProps> = ({
  listUuid,
  listEntity,
}) => {
  const translate = useTranslate();
  const [listEntityFields, toggleListEntityFields] = useState<
    ListEntityField[] | undefined
  >(undefined);
  const [entityCollections, toggleEntityCollections] = useState<
    EntityCollection[] | undefined
  >(undefined);
  const locale = useLocale();

  const update = async () => {
    // get fields
    const listEntityFields = await userDoGetListEntityFields(
      listUuid,
      listEntity.uuid,
    );
    toggleListEntityFields(listEntityFields);

    // get collections
    const entityCollections = await userDoGetEntityCollections(listEntity.uuid);
    toggleEntityCollections(entityCollections);
  };

  useEffect(() => {
    // update every time entity uuid changes
    update();
  }, [listEntity.uuid]);

  if (!listEntityFields || !entityCollections) {
    return null;
  }

  const columns: ColumnInterface[] = [];
  addEntityCollectionColumns(
    listEntity.schema,
    locale,
    [{ ...listEntity, listEntityFields }],
    columns,
    translate,
  );

  return (
    <Fragment>
      <Table
        name={`entity-${listEntity.uuid}`}
        columns={columns}
        data={entityCollections}
      />
    </Fragment>
  );
};

export default MultiSummaryTable;
